import React, { FC } from 'react';
import Alert, { AlertProps } from '@mui/material/Alert';
import { styled } from '@mui/material';
import { blend } from '@mui/system';
import { WarningAmber } from '@mui/icons-material';
import { Colors } from '../../colors';

const StyledAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: blend(theme.palette.background.paper, theme.palette.warning.main, 0.1),
  color: blend(theme.palette.warning.main, Colors.White, 0.6),
  letterSpacing: '0.16px',
}));

const StyledIcon = styled(WarningAmber)(({ theme }) => ({
  color: blend(theme.palette.warning.main, Colors.White, 0.6),
}));

export const WarningAlert: FC<Omit<AlertProps, 'severity'>> = (props) => {
  return <StyledAlert severity="warning" {...props} icon={<StyledIcon />}></StyledAlert>;
};
